// Stałe dla systemu celów sprzedażowych

// Typy celów
export const TARGET_TYPES = {
  sales_value: 'Wartość sprzedaży',
  leads_count: 'Liczba leadów',
  meetings_count: 'Liczba spotkań',
  new_clients_count: 'Liczba nowych klientów',
  items_sold: 'Liczba sprzedanych produktów'
};

// Statusy celów
export const GOAL_STATUSES = {
  in_progress: 'W trakcie',
  achieved: 'Osiągnięty',
  missed: 'Nieosiągnięty',
  overachieved: 'Przekroczony'
};

// Okresy celów
export const GOAL_PERIODS = {
  monthly: 'Miesięczny',
  quarterly: 'Kwartalny',
  yearly: 'Roczny'
};

// Miesiące
export const MONTHS = {
  1: 'Styczeń',
  2: 'Luty',
  3: 'Marzec',
  4: 'Kwiecień',
  5: 'Maj',
  6: 'Czerwiec',
  7: 'Lipiec',
  8: 'Sierpień',
  9: 'Wrzesień',
  10: 'Październik',
  11: 'Listopad',
  12: 'Grudzień'
};

// Kwartały
export const QUARTERS = {
  1: 'I kwartał',
  2: 'II kwartał',
  3: 'III kwartał',
  4: 'IV kwartał'
};

// Funkcje pomocnicze
export const getTargetTypeLabel = (targetType) => {
  return TARGET_TYPES[targetType] || targetType;
};

export const getStatusLabel = (status) => {
  return GOAL_STATUSES[status] || status;
};

export const getMonthLabel = (month) => {
  return MONTHS[month] || month;
};

export const getQuarterLabel = (quarter) => {
  return QUARTERS[quarter] || quarter;
};

export const getPeriodLabel = (year, month, quarter) => {
  if (month) {
    return `${getMonthLabel(month)} ${year}`;
  } else if (quarter) {
    return `${getQuarterLabel(quarter)} ${year}`;
  } else {
    return `${year}`;
  }
};

// Kolory statusów
export const getStatusColor = (status) => {
  switch (status) {
    case 'in_progress':
      return 'info';
    case 'achieved':
      return 'success';
    case 'missed':
      return 'error';
    case 'overachieved':
      return 'success';
    default:
      return 'default';
  }
};

// Kolory pasków postępu
export const getProgressColor = (progress, target) => {
  const percentage = (progress / target) * 100;
  
  if (percentage >= 100) {
    return 'success';
  } else if (percentage >= 75) {
    return 'info';
  } else if (percentage >= 50) {
    return 'warning';
  } else {
    return 'error';
  }
};

// Funkcja generująca daty początku i końca okresu
export const generatePeriodDates = (year, month, quarter) => {
  if (month) {
    // Cel miesięczny
    const startDate = new Date(year, month - 1, 1);
    const endDate = new Date(year, month, 0, 23, 59, 59, 999);
    return { startDate, endDate };
  } else if (quarter) {
    // Cel kwartalny
    const startMonth = (quarter - 1) * 3;
    const startDate = new Date(year, startMonth, 1);
    const endDate = new Date(year, startMonth + 3, 0, 23, 59, 59, 999);
    return { startDate, endDate };
  } else {
    // Cel roczny
    const startDate = new Date(year, 0, 1);
    const endDate = new Date(year, 11, 31, 23, 59, 59, 999);
    return { startDate, endDate };
  }
};
